import { useEffect, useState } from 'react';
import { Grid, IconButton, Typography, Box, CircularProgress } from '@mui/material';
import { CancelPresentationRounded, NavigateNext, NavigateBefore } from '@mui/icons-material';
import PropTypes from 'prop-types';
import styles from './styles';
import Carousel from 'react-material-ui-carousel';
import { useDispatch } from 'react-redux';
import ModalDialog from '../ModalDialog';
import CheckinsPhotoCard from '../../checkIns/checkinsPicturesModal/checkinsPhotoCard';

const PicturesModal = ({
  handleClose,
  data,
  open,
  getPictures
}) => {
  const classes = styles();
  const dispatch = useDispatch();
  const [pictures, setPictures] = useState([]);
  const [picturesLoading, setPicturesLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalPages = !picturesLoading.loading && Math.ceil(pictures.length / 3);

  useEffect(() => {
    if (data?._id) {
      setPicturesLoading(true);
      dispatch(getPictures(data._id, (data) => {
        if (data?.length) {
          setPictures(data);
        }
        setPicturesLoading(false);
      }));
    }
  }, [data._id]);

  const getModalTitle = () => {
    return (
      <>
      <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
           {data?.BinNum}
          </Grid>
          <Grid item>
          <IconButton
              onClick={handleClose}
            >
              <CancelPresentationRounded fontSize='large'/>
            </IconButton>
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <ModalDialog
      title={getModalTitle()}
      isOpen={open}
      onClose={handleClose}
      maxWidth="lg"
      dialogClass={classes.dialogModal}
    >
      <Grid container spacing={2} marginTop="20px" minHeight="450px" justifyContent="center">
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          {picturesLoading
            ? (
              <Grid container justifyContent={'center'} alignItems={'center'} sx={{ height: '400px' }}>
                <CircularProgress />
              </Grid>
              )
            : (
              <>
                {pictures?.length > 0
                  ? (
                  <Carousel
                    swipe={false}
                    autoPlay={false}
                    NextIcon={<NavigateNext />}
                    PrevIcon={<NavigateBefore />}
                    className={classes.carousel}
                    index={currentIndex}
                    onChange={(index) => setCurrentIndex(index)}
                    navButtonsWrapperProps={{
                      style: {
                        display: 'none',
                      }
                    }}
                    indicatorContainerProps={{
                      style: {
                        zIndex: 1,
                        marginBottom: '20px',
                      }
                    }}
                  >
                    {Array.from({ length: totalPages }).map((_, pageIndex) => (
                      <Box
                        key={pageIndex}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                        padding="0 10px"
                      >
                        {/* Previous Icon */}
                        <IconButton
                          disableRipple
                          onClick={() => setCurrentIndex(Math.max(0, currentIndex - 1))}
                          disabled={currentIndex === 0}
                          className={classes.actionIcon}
                        >
                          <NavigateBefore sx={{ fontSize: '50px' }} />
                        </IconButton>

                        {/* Cards */}
                        <Grid container spacing={2} justifyContent="center" sx={{ flexGrow: 1, height: '450px' }}>
                          {pictures.slice(pageIndex * 3, pageIndex * 3 + 3).map((item, index) => (
                            <Grid item xs={4} key={index}>
                              <CheckinsPhotoCard
                                image={item}
                                inView={pageIndex === 0}
                              />
                            </Grid>
                          ))}
                        </Grid>

                        {/* Next Icon */}
                        <IconButton
                          disableRipple
                          onClick={() => setCurrentIndex(Math.min(totalPages - 1, currentIndex + 1))}
                          disabled={currentIndex === totalPages - 1}
                          className={classes.actionIcon}
                        >
                          <NavigateNext sx={{ fontSize: '50px' }} />
                        </IconButton>
                      </Box>
                    ))}
                  </Carousel>
                    )
                  : (
                  <Typography variant="h6" sx={{ textAlign: 'center' }}>
                    No Images Found
                  </Typography>
                    )}
              </>
              )}
        </Grid>
      </Grid>
    </ModalDialog>
  );
};

PicturesModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  getPictures: PropTypes.func
};

export default PicturesModal;
